import React, { useEffect, useRef } from "react";
import "./Menu.css";
import Categories from "./Categories.jsx";
import { use } from "react";

const NavBar = ({
  actualCategory,
  changeActualCategory,
  changeActualAction,
}) => {
  const categories = useRef(Categories);
  const handleClick = (index) => {
    changeActualCategory(index);
    changeActualAction("Click");
  };

  return (
    <nav
      id="nav-bar"
      className="flex gap-10 overflow-x-scroll transition-all duration-700 ease-in-out pb-4 lg:justify-center lg:min-h-[150px] border-b-[4px]  border-b-mariposa"
    >
      {categories.current.length > 0 ? (
        categories.current.map((category, index) => (
          <button
            key={index}
            className={`nav-element ${actualCategory === index ? " scale-110 text-pink-500" : ""}  flex-1 flex-col h-[100%]  w-[100px] min-w-[80px] items-center `}
            onClick={() => handleClick(index)}
          >
            <div className="w-[100%] h-[60%] pt-4 flex justify-center items-center">
              <img
                src={category["image"]}
                alt={category["category"]}
                className="w-[90px] h-[100%]"
              />
            </div>

            <div
              className={`font-Roboto font-[600] flex justify-center text-wrap items-start  w-[100%] h-[40%] ${actualCategory === index ? "border-b-[0px] border-mariposa lg:border-b-0" : ""}`}
            >
              {category["category"]}
            </div>
          </button>
        ))
      ) : (
        <li> Cargando Menu</li>
      )}
    </nav>
  );
};

export default NavBar;
